import type { TrackingProps } from '@seek/tealium-adapter/lib-types/types';
import { useTranslations } from '@vocab/react';
import { IconOverflow } from 'braid-design-system';
import { useRef } from 'react';

import { EVENT_NAME_JOB_ACTION_MENU_PRESSED } from 'src/App/constants/tracking';

import { IconButtonWithoutTooltip as Trigger } from '../../IconButtonLink/IconButtonWithoutTooltip';
import translations from '../.vocab';
import type { JobActionMenuOption } from '../useJobActionMenuOptions';

import { DropdownMenuContainer } from './DropdownMenuContainer';

interface JobActionMenuDesktopProps {
  disabled?: boolean;
  eventAttributesProps?: TrackingProps;
  id: string;
  jobActionMenuOptions: JobActionMenuOption[];
  onAction(value: string): void;
}

export const JobActionMenuDesktop: React.FC<
  React.PropsWithChildren<JobActionMenuDesktopProps>
> = ({
  disabled,
  eventAttributesProps,
  id,
  jobActionMenuOptions,
  onAction,
}) => {
  const { t } = useTranslations(translations);
  const triggerRef = useRef<HTMLButtonElement>(null);

  return (
    <DropdownMenuContainer
      aria-label={t('Menu')}
      menuWidth={380}
      options={jobActionMenuOptions}
      onDropdownMenuClick={onAction}
      triggerRef={triggerRef}
      disabled={disabled}
    >
      {({ open }) => (
        <Trigger
          active={open}
          dataTestId="job-action-dropdown-menu-trigger"
          eventAttributes={eventAttributesProps}
          eventName={EVENT_NAME_JOB_ACTION_MENU_PRESSED}
          hoverBackground="formAccentSoft"
          icon={<IconOverflow titleId={`${id}-menu`} title={t('Menu')} />}
          ref={triggerRef}
          disabled={disabled}
        />
      )}
    </DropdownMenuContainer>
  );
};
